<script setup lang="ts">
import { Button } from '~ds/components/ui/button';
import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';

import { useShareLink } from '~/composables/useShareLink';

interface Props {
  title: string;
  url: string;
}

const props = defineProps<Props>();

const { shareLink, shared } = useShareLink();

const share = () => {
  void shareLink(props.url, { title: props.title }, 'video share');
};
</script>

<template>
  <Button
    variant="secondary"
    size="sm"
    type="button"
    data-testid="video-share"
    @click="share"
  >
    <Icon :name="ICONS.share" />
    <span aria-live="polite">{{ shared ? $t('unified.videos.linkCopied') : $t('unified.videos.share') }}</span>
  </Button>
</template>
